import React from 'react';
import { Link } from 'react-router-dom';
import { Tramite } from '../types';
import clsx from 'clsx';
import SubtramiteStatusBadge from '@/subtramites/SubtramiteStatusBadge';
import { checkAllPermissions, PERMISSIONS } from '@/auth/permissions';
import { useAuth } from '@/auth';

export interface CardTramiteProps {
  title: string;
  href: string;
  disabled?: boolean;
  model?: Tramite;
  categoria?: string;
  visible?: boolean;
  subtramite?: any; // Optional subtramite data
  canActivate?: boolean;
  canChangeName?: boolean;
}

const CardTramite: React.FC<CardTramiteProps> = ({
  title,
  href,
  disabled = false,
  categoria,
  model,
  visible = true,
  subtramite,
  canActivate = false,
  canChangeName = true,
}) => {
  const { user } = useAuth();
  const userPermissions = user?.permissions || [];
  const canManageTramites = checkAllPermissions(userPermissions, [
    PERMISSIONS.MANAGE_TRAMITES.name
  ]);

  if (!visible || (!canManageTramites && !canActivate && disabled)) return null;

  const cardClasses = clsx(
    'relative flex items-center justify-center h-[224px] rounded-lg shadow-md transition-colors duration-200',
    {
      'bg-gray-200': disabled,
      'bg-blue-500 hover:bg-blue-600 text-white': !disabled
    }
  );

  const contentClasses = clsx(
    'w-full bg-white overflow-hidden flex flex-wrap items-center justify-center gap-2 px-3 text-center break-words h-full text-sm md:text-base transition-colors duration-200',
    {
      'text-gray-300': disabled,
      'text-black hover:bg-blue-300 hover:text-white': !disabled
    }
  );

  return (
    <Link
      to={href}
      state={{
        tramite: model,
        categoria: categoria,
        canChangeName
      }}
      className={cardClasses}
    >
      <div className={contentClasses}>
        {title}
        {canManageTramites && (
          <SubtramiteStatusBadge subtramite={subtramite} />
        )}
      </div>
    </Link>
  );
};

export default CardTramite;
